/* LukyNeko custom JS. Our own file: survives theme updates. Loaded from snippets/head-variables.liquid.
   Source of truth: Claude/2.Lukyneko/shopify/theme-custom-code/THEME_CUSTOM_EDITS.md */
document.addEventListener('DOMContentLoaded', function(){

  /* A. Desktop menu inline with the logo */
  try {
    var top = document.querySelector('.header__top');
    var logo = top && top.querySelector('#logo');
    var bottom = document.querySelector('.header-container--bottom');
    var bottomInner = bottom && bottom.querySelector('.header__bottom');
    var nav = bottomInner && bottomInner.querySelector('scrollable-navigation.header-links');
    if (top && logo && bottom && nav && !top.querySelector('.header__nav-inline')) {
      var inline = document.createElement('div');
      inline.className = 'header__nav-inline portable-hide';
      var left = bottomInner.querySelector('.scrollable-navigation-button--left');
      var right = bottomInner.querySelector('.scrollable-navigation-button--right');
      if (left) inline.appendChild(left);
      inline.appendChild(nav);
      if (right) inline.appendChild(right);
      logo.insertAdjacentElement('afterend', inline);
      bottom.classList.add('header-menu-bottom');
    }
  } catch (e) { console.warn('lukyneko header', e); }

  /* B. Legal links in the footer bottom bar, from the footer menu column */
  try {
    var fb = document.querySelector('.footer-bottom .rte');
    var legalMenu = Array.prototype.find.call(document.querySelectorAll('.footer-item__menu'), function(m){ return m.querySelector('a[href*="privacy"]'); });
    if (fb && legalMenu && !fb.querySelector('.footer-bottom__legal-links')) {
      var navL = document.createElement('nav');
      navL.className = 'footer-bottom__legal-links';
      legalMenu.querySelectorAll('a').forEach(function(a){
        var l = document.createElement('a'); l.href = a.getAttribute('href'); l.textContent = a.textContent.trim(); navL.appendChild(l);
      });
      var loc = fb.querySelector('.localization-form');
      if (loc) fb.insertBefore(navL, loc.nextSibling); else fb.appendChild(navL);
    }
  } catch (e) { console.warn('lukyneko footer', e); }

  /* C. Newsletter layout classes */
  try {
    document.querySelectorAll('.card.newsletter').forEach(function(c){
      c.classList.add('newsletter--left-aligned');
      var fs = c.querySelector('fieldset'); if (fs) fs.classList.add('newsletter__form-wrapper');
    });
  } catch (e) { console.warn('lukyneko newsletter', e); }

  /* D. Sharper images in Directions for use (theme loads them at 120 px) */
  try {
    document.querySelectorAll('[id*="__text_columns_images"] img').forEach(function(img){
      ['src','srcset'].forEach(function(att){
        var v = img.getAttribute(att);
        if (v) img.setAttribute(att, v.replace(/width=120/g,'width=300').replace(/height=120/g,'height=300'));
      });
    });
  } catch (e) { console.warn('lukyneko images', e); }
});

/* E. Full screen product image viewer, product pages only */
if (location.pathname.indexOf('/products/') !== -1) {
  document.addEventListener('DOMContentLoaded', function(){
    var targetW = 1200; // medium sharp and fast

    // build overlay
    var overlay = document.createElement('div');
    overlay.className = 'lnOverlay';
    overlay.id = 'lnOverlay';
    overlay.innerHTML =
      '<button class="lnClose" aria-label="Close">&#10005;</button>' +
      '<div class="lnIndex" id="lnIndex"></div>' +
      '<div class="lnWrap" id="lnWrap"><div class="lnCol" id="lnCol"></div></div>' +
      '<div class="lnHint">Scroll to browse. Press Esc to close.</div>';
    document.body.appendChild(overlay);

    var wrap = overlay.querySelector('#lnWrap');
    var col  = overlay.querySelector('#lnCol');
    var btnClose = overlay.querySelector('.lnClose');
    var idxLabel = overlay.querySelector('#lnIndex');

    function bestSrc(el, w){
      w = w || targetW;
      if (el && el.srcset){
        var list = el.srcset.split(',').map(function(s){
          var p = s.trim().split(' ');
          return {url:p[0], w:parseInt(p[1])||0};
        }).sort(function(a,b){return a.w-b.w;});
        var pick = list.find(function(c){return c.w>=w;}) || list[list.length-1] || {url:el.currentSrc||el.src};
        var url = pick.url || '';
        if (/_\d+x\d*/.test(url)) return url.replace(/_\d+x\d*/,'_'+w+'x'+w);
        if (url.indexOf('cdn.shopify.com')!==-1) return url.replace(/(\?v=\d+|%3Fv%3D\d+)?$/,'') + '?width=' + w;
        return url;
      }
      var url2 = (el && (el.currentSrc||el.src)) || '';
      if (/_\d+x\d*/.test(url2)) return url2.replace(/_\d+x\d*/,'_'+w+'x'+w);
      if (url2.indexOf('cdn.shopify.com')!==-1) return url2.replace(/(\?v=\d+|%3Fv%3D\d+)?$/,'') + '?width=' + w;
      return url2;
    }

    // find the correct gallery root from the clicked image
    function findGalleryRoot(img){
      return img.closest('.product__media-list')
          || img.closest('[data-product-media]')
          || img.closest('.product-gallery')
          || img.closest('.section-main-product')
          || img.closest('section')
          || document.querySelector('.section-main-product');
    }

    function collectGalleryImages(root){
      if(!root) return [];
      // only real product media, exclude recommendations and anything outside
      var imgs = Array.from(root.querySelectorAll('[data-media-id] img, .product__media img, .lazy-image img, img'))
        .filter(function(im){
          if(!im || !im.src) return false;
          if (im.closest('.product-recommendations, .related-products, .recommendations, footer, header')) return false;
          // keep only images that sit inside a media item container
          return im.closest('[data-media-id], .product__media, .product__media-item');
        });

      // unique order preserving
      var seen = new Set(), out = [];
      imgs.forEach(function(im){ if(!seen.has(im)) { seen.add(im); out.push(im); } });
      return out;
    }

    function openOverlay(clickedIndex, galleryRoot){
      var imgs = collectGalleryImages(galleryRoot);
      if(!imgs.length) return;

      col.innerHTML = '';
      imgs.forEach(function(srcImg){
        var holder = document.createElement('img');
        holder.alt = srcImg.alt || '';
        holder.setAttribute('data-src', bestSrc(srcImg, targetW));
        holder.setAttribute('loading', 'lazy');
        col.appendChild(holder);
      });

      overlay.classList.add('show');
      document.body.style.overflow = 'hidden';

      // lazy load
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(ent){
          if(ent.isIntersecting){
            var img = ent.target;
            if(!img.src) img.src = img.getAttribute('data-src');
            io.unobserve(img);
          }
        });
      }, {root: wrap, rootMargin: '200px 0px', threshold: 0.01});
      Array.from(col.children).forEach(function(im){ io.observe(im); });

      // jump to the clicked image
      if (clickedIndex != null){
        var el = col.children[clickedIndex];
        if (el) wrap.scrollTo({ top: el.offsetTop - 20, behavior: 'instant' });
      }

      // index updater
      function updateIndex(){
        var items = Array.from(col.children);
        var viewTop = wrap.scrollTop + 1;
        var current = items.findIndex(function(im){ return im.offsetTop + im.clientHeight > viewTop; });
        idxLabel.textContent = (current+1) + ' / ' + items.length;
      }
      wrap.addEventListener('scroll', updateIndex, {passive:true});
      updateIndex();

      function close(){
        overlay.classList.remove('show');
        document.body.style.overflow = '';
        wrap.removeEventListener('scroll', updateIndex);
      }
      btnClose.onclick = close;
      overlay.addEventListener('click', function(e){ if(e.target === overlay) close(); });
      document.addEventListener('keydown', function onKey(e){
        if(e.key === 'Escape'){ close(); document.removeEventListener('keydown', onKey); }
      });
    }

    // bind only to product gallery images
    function bindThumbs(){
      var scope = document.querySelector('.section-main-product') || document;
      var thumbs = Array.from(scope.querySelectorAll('[data-media-id] img, .product__media img, .product__media-item img'))
        .filter(function(img){ return img && img.src && !img.dataset.lnBound; });

      thumbs.forEach(function(img){
        img.dataset.lnBound = '1';
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', function(e){
          e.preventDefault();
          var root = findGalleryRoot(img);
          var all = collectGalleryImages(root);
          var clickedIndex = all.indexOf(img);
          openOverlay(clickedIndex, root);
        });
      });
    }

    bindThumbs();
    var watch = document.querySelector('.section-main-product') || document.body;
    new MutationObserver(bindThumbs).observe(watch, {childList:true, subtree:true});
  });
  
}

/* F. Lucky Bag gift set guard (2026-10-02, task T20261001_1030_commerce_bq). Every page.
   One gift set from 5 pairs, two from 10 pairs, none under 5 pairs and never alone.
   Pairs = cart lines with a SKU starting LN-SO-. Gift set = product handle lucky-bag-2027-gift-set (0 EUR).
   window.LNGift.sync() is also called by the pack page after an add (assets/lukyneko-luckybag.js). */
(function () {
  var GIFT = 'lucky-bag-2027-gift-set';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';
  var busy = false, info = null, timer = null;
  function getJSON(u) { return fetch(u, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(u, body) { return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); }); }
  function giftInfo() {
    if (info) return Promise.resolve(info);
    return getJSON(root + 'products/' + GIFT + '.js').then(function (p) { info = { id: p.variants[0].id, ok: !!p.variants[0].available }; return info; })
      .catch(function () { info = { id: null, ok: false }; return info; });
  }
  function sync(opt) {
    opt = opt || {};
    if (busy) return Promise.resolve(false);
    busy = true;
    return getJSON(root + 'cart.js').then(function (cart) {
      var pairs = 0, gifts = [], have = 0;
      (cart.items || []).forEach(function (it) {
        if (it.handle === GIFT) { gifts.push(it); have += it.quantity; }
        else if (it.sku && it.sku.indexOf('LN-SO-') === 0) pairs += it.quantity;
      });
      var want = pairs >= 10 ? 2 : (pairs >= 5 ? 1 : 0);
      if (want === have) return false;
      return giftInfo().then(function (g) {
        if (!g.ok || !g.id) want = 0;
        if (want === have) return false;
        if (gifts.length) {
          var updates = {};
          gifts.forEach(function (it, i) { updates[it.key] = i === 0 ? want : 0; });
          return post(root + 'cart/update.js', { updates: updates }).then(function () { return true; });
        }
        return post(root + 'cart/add.js', { items: [{ id: g.id, quantity: want }] }).then(function () { return true; });
      });
    }).then(function (changed) {
      busy = false;
      if (changed && !opt.silent) {
        if (/\/cart\/?$/.test(location.pathname)) location.reload();
        else if (typeof window.refreshCart === 'function') window.refreshCart(false);
      }
      return changed;
    }).catch(function (e) { busy = false; console.warn('lukyneko gift set', e); return false; });
  }
  function later() { clearTimeout(timer); timer = setTimeout(sync, 300); }
  window.LNGift = { sync: sync };
  document.addEventListener('DOMContentLoaded', function () {
    sync();
    var form = document.getElementById('AjaxCartForm');
    if (form && window.MutationObserver) new MutationObserver(later).observe(form, { childList: true });
    document.addEventListener('krown:cart:update', later);
  });
})();
